import React from "react";
import AuthClient from "../../api/AuthClient";
import BookingType from "../../api/enums/BookingType";
import SortPartyGroupsByDate from "../../SortPartyGroupsByDate";
import { PartyModel } from "../../types";
import styles from "../MyPartyDetail/myPartyDetail.module.scss";
import AlsoGoingOutGroupDetail from "./AlsoGoingOutGroups";
import PartyTabSkeleton from "./PartyTabSkeleton";

interface AlsoGoingOutContentProps {
  isLoadingGroups: boolean;
  alsoGoingOutGroups: PartyModel[];
  authClient: AuthClient;
}

const AlsoGoingOutContent: React.FC<AlsoGoingOutContentProps> = ({
  isLoadingGroups,
  alsoGoingOutGroups,
  authClient,
}) => {
  if (isLoadingGroups) {
    return <PartyTabSkeleton showGroupedLayout />;
  }

  const mapBookingType = (bookingTypeString: string): BookingType => {
    switch (bookingTypeString.toLowerCase()) {
      case "guestlist":
        return BookingType.GuestList;
      case "tablebooking":
        return BookingType.TableBooking;
      default:
        return BookingType.NotSet;
    }
  };

  const hasTableBooking = alsoGoingOutGroups.some((obj) => {
    const enumValue = mapBookingType(obj.party.bookingType.toString());
    return enumValue === BookingType.TableBooking;
  });

  const hasGuestList = alsoGoingOutGroups.some((obj) => {
    const enumValue = mapBookingType(obj.party.bookingType.toString());
    return enumValue === BookingType.GuestList;
  });

  const tableGroups = alsoGoingOutGroups.filter(
    (group) => mapBookingType(group.party.bookingType.toString()) === BookingType.TableBooking
  );

  const guestGroups = alsoGoingOutGroups.filter(
    (group) => mapBookingType(group.party.bookingType.toString()) === BookingType.GuestList
  );

  if (alsoGoingOutGroups.length === 0) {
    return <div className="m-4 p-4 text-white text-center">No groups</div>;
  }

  return (
    <>
      {hasTableBooking && (
        <div className="goingOutHeading d-flex w-100">
          <p> VIP Table Groups </p>
        </div>
      )}
      {hasTableBooking &&
        SortPartyGroupsByDate(tableGroups)?.map((group: PartyModel) => (
          <div key={group.party.id}>
            <AlsoGoingOutGroupDetail
              authClient={authClient}
              alsoGoingOutGroups={alsoGoingOutGroups}
              group={group}
            />
          </div>
        ))}
      <div className={styles.line} />
      {hasGuestList && (
        <div className="goingOutHeading d-flex w-100">
          <p> GuestList </p>
        </div>
      )}
      {hasGuestList &&
        SortPartyGroupsByDate(guestGroups)?.map((group: PartyModel) => (
          <div key={group.party.id}>
            <AlsoGoingOutGroupDetail
              authClient={authClient}
              alsoGoingOutGroups={alsoGoingOutGroups}
              group={group}
            />
          </div>
        ))}
    </>
  );
};

export default AlsoGoingOutContent;
